

const MarkdownComponents = {
    h1 (props) {
	const {node, ...rest} = props;
	return (<div className="mb-1 fs-4 fw-medium" {...rest} />);
    },
    
    h2 (props) {
	const {node, ...rest} = props;
	return (<div className="mt-3 mb-1 fs-5 fw-medium" {...rest} />);
    },
    
    h3 (props) {
	const {node, ...rest} = props;
	return (<div className="mt-3 mb-1 fs-6 fw-medium" {...rest} />);
    },
    
    ul (props) {
	const {node, ...rest} = props;
	return (<ul className="m-0" {...rest} />);
    },

    li (props) {
	const {node, ...rest} = props;
	return (<li className="mb-1" {...rest} />);
    },

    strong (props) {
	const {node, ...rest} = props;
	return (<strong style={{ color: "DarkSlateGrey" }} {...rest} />);
    },

    table (props) {
	return (<table style={{ marginBottom: "10px", border: "DarkSlateGrey 2px solid" }} {...props} />);
    },

    td (props) {
	return (<td style={{ padding: "8px", textAlign: "right", border: "DarkSlateGrey 1px solid" }} {...props} />);
    },

    th (props) {
	return (<th style={{ padding: "8px", textAlign: "right", border: "DarkSlateGrey 1px solid", color: "white", backgroundColor: "DarkSlateGrey" }} {...props} />);
    }
};

export default MarkdownComponents;
